import type { FC, ReactElement } from "react";

import { OverflowContainer } from "overflwn";

import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { COMPANY_ANALYSIS_SIGNALS } from "app/pages/sales-intelligence/constants/routes";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { StyledSignalBoxTag } from "app/pages/sales-intelligence/pages/company-analysis/components/cards/signals-card/SignalEventBoxItem/styles";
import SignalsTooltip from "app/pages/sales-intelligence/sub-modules/signals/components/tooltips/SignalsTooltip/SignalsTooltip";
import { TOOLTIP_DEBOUNCE_TIME } from "app/pages/sales-intelligence/sub-modules/signals/constants";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { StyledShowMoreButton } from "./styles";

type Props = {
    topics: { topic: string; tooltipContent: string | number | ReactElement }[];
};

const IntentSignalEventTopics: FC<Props> = ({ topics }) => {
    const handleAllSignalsClick = () => void proNavigator.go(COMPANY_ANALYSIS_SIGNALS);

    const handleTrackedMouseEnter = (): void => {
        companyAnalysisTrackingService.signalEvents.trackHoverIntentTrend();
    };

    return (
        <Box margin="4px 0 0">
            <OverflowContainer
                renderHiddenElements={() => (
                    <StyledShowMoreButton
                        type="flat"
                        onClick={handleAllSignalsClick}
                    >
                        {translate("si.company-analysis.signals.card.all-topics")}
                    </StyledShowMoreButton>
                )}
                gap={4}
            >
                {topics.map(({ topic, tooltipContent }) => (
                    <SignalsTooltip
                        debounce={TOOLTIP_DEBOUNCE_TIME}
                        placement="top"
                        content={tooltipContent}
                        key={topic}
                    >
                        <StyledSignalBoxTag
                            onMouseEnter={handleTrackedMouseEnter}
                            key={topic}
                        >
                            {topic}
                        </StyledSignalBoxTag>
                    </SignalsTooltip>
                ))}
            </OverflowContainer>
        </Box>
    );
};

export default IntentSignalEventTopics;
